import { createFileRoute } from "@tanstack/react-router";
import Page from "@/pages/reset-password";
import { buildNoindexHead } from "@/lib/noindex-seo";

export const Route = createFileRoute("/reset-password")({
  head: () => buildNoindexHead("Set a New Password", "/reset-password"),
  component: Page,
});
